import React from "react";
import { Menu } from "semantic-ui-react";
import UserPanel from "./UserPanel";
import Channels from "./Channels";
import DirectMessges from "./DirectMessages";
import Starred from "./Starred";

class SidePanel extends React.Component {
  render() {
    const { currentUser, primaryColor } = this.props;
    return (
      <Menu
        size="large"
        inverted
        fixed="left"
        vertical
        style={{ background: primaryColor, fontsize: "1.2rem" }}
      >
        <UserPanel primaryColor={primaryColor} currentUser={currentUser} />
        <Channels currentUser={currentUser} />
        <DirectMessges currentUser={currentUser} />
        <Starred currentUser={currentUser} />
      </Menu>
    );
  }
}

export default SidePanel;



// WEBPACK FOOTER //
// ./src/components/SidePanel/SidePanel.js